var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page-top"}},[_c('the-main-nav'),_c('v-main',{attrs:{"id":"full-container-content"}},[(!_vm.$slots.default)?_c('router-view'):_vm._e(),_vm._t("default")],2),_c('the-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }